module.exports = __webpack_public_path__ + "img/11_non_open_L2.4953885c.svg";